// theme.ts
export const COLORS = {
  colorWhite: "#fff",
  colorBlack: "#000",
  colorPrimary: "#b5272e",
  colorSecondary: "#e56425",
  colorYellow: "#fbb03b",
  colorOrange: "#f7931e",
  colorHeaderBackground: "#ffffff",
  colorHeaderTopBar: "#b5272e",
  colorBooter: "#ffffff",
  colorNavSelector: "#e56425",
  colorBackgroundDefault: "#333",
  colorFontDefault: "#000",
  colorWhitesmoke: "whitesmoke",
  colorTransparent: "transparent",
  colorDarkMode: "#242424",
  colorRed: "#fa5252",
};
